export const HOME = {
  hero: "home-hero",
  slogan: "home-slogan",
  searchInput: "home-search-input",
  searchButton: "home-search-button",
  postAdCTA: "home-post-ad-cta",
  proSection: "home-pro-section",
};

export const AUTH = {
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  registerEmail: "register-email",
  registerPassword: "register-password",
  registerFullName: "register-full-name",
  registerRoleParticulier: "register-role-particulier",
  registerRolePro: "register-role-pro",
  registerCompanyName: "register-company-name",
  registerCompanyNumber: "register-company-number",
  registerSubmit: "register-submit",
  registerCity: "register-city",
  registerPostalCode: "register-postal-code",
  registerPhone: "register-phone",
};

export const NAV = {
  logo: "nav-logo",
  desktopLogin: "nav-desktop-login",
  desktopRegister: "nav-desktop-register",
  desktopPostAd: "nav-desktop-post-ad",
  desktopHome: "nav-desktop-home",
  desktopProfile: "nav-desktop-profile",
  desktopLogout: "nav-desktop-logout",
  mobileHome: "mobile-nav-home",
  mobileSearch: "mobile-nav-search",
  mobilePost: "mobile-nav-post",
  mobileMessages: "mobile-nav-messages",
  mobileProfile: "mobile-nav-profile",
};
